import React from 'react';
import ReactPlayer from 'react-player';

import './video.less';

export interface VideoProps {
    featuredVideo: any;
    options?: any;
}

const Video = ({ featuredVideo }: VideoProps) => {
    return (
        <div data-testid="atl-video-player" className="player-wrapper">
            <ReactPlayer
                className="react-player"
                url={featuredVideo.videoUrl}
                width="100%"
                height="100%"
            />
        </div>
    );
};

export default Video;
